import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { CalendarModule } from '../../../shared/components/calendar';
import { ClientePipeSharedModule } from '../../pessoa/cliente/pipes';
import { AtividadeTipoPipeModule } from '../tipo/pipes';
import { AtividadeCalendarComponent } from './atividade-calendar.component';

@NgModule({
    imports: [
        SharedModule,
        CalendarModule,
        AtividadeTipoPipeModule,
        ClientePipeSharedModule
    ],
    declarations: [
        AtividadeCalendarComponent
    ],
    exports: [
        AtividadeCalendarComponent
    ]
})
export class AtividadeCalendarModule { }
